var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.413 1.95A1.18 1.18 0 0 0 12.518 0H7.793a1.18 1.18 0 0 0-.896 1.95C2.888 3.309 0 7.104 0 11.573c0 5.609 4.547 10.156 10.155 10.156 5.609 0 10.156-4.547 10.156-10.156 0-4.469-2.887-8.264-6.898-9.621Zm-3.258 1.356a8.266 8.266 0 1 0 0 16.532 8.266 8.266 0 0 0 0-16.532Zm-.709 9.211c0 .391.318.709.709.709h3.306a.708.708 0 1 0 0-1.418h-2.598V7.795a.709.709 0 1 0-1.417 0v4.723Z",
    fill: "currentColor"
  })));
};
export default SvgClock;